<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font">{{ name }}</span>
    </div>

    <div class="center"
         style="position:relative">
      <div class="shangjia">
        <el-button size="small"
                   type="primary"
                   @click="clickBtn('add')">添加属性</el-button>
      </div>
      <MyTable :table-data="tableData"
               :showpage="showpage"
               :index="index"
               :operation="operation"
               :table-option.sync="tableOption">
        <template slot="listPageFilter"
                  slot-scope="scope">
          {{ scope.row.listPageFilter ? '√':'' }}
        </template>
        <template slot="mallDetailPage"
                  slot-scope="scope">
          {{ scope.row.mallDetailPage ? '√':'' }}
        </template>
        <template slot="goodsBaseShow"
                  slot-scope="scope">
          {{ scope.row.goodsBaseShow ? '√':'' }}
        </template>
        <template slot="required"
                  slot-scope="scope">
          {{ scope.row.required ? '√':'' }}
        </template>
        <template slot="input"
                  slot-scope="scope">
          {{ scope.row.input == '0' ? '文本框':scope.row.input == '1'? '多行文本框' :scope.row.input == '2'? '下拉框':scope.row.input == '3'?'上传文件':'' }}
        </template>
        <template slot="menu"
                  slot-scope="scope">
          <!-- <el-button type="button" size="mini" icon="el-icon-upload2" @click="deleteHandle(scope.row)">上架</el-button> -->

          <el-link :underline="false"
                   type="primary"
                   @click="editHandle(scope.row)">编辑</el-link>
          <el-link :underline="false"
                   style="margin-left:16px"
                   type="primary"
                   @click="deleteHandle(scope.row)">删除</el-link>
        </template>
      </MyTable>
    </div>
    <el-dialog title="信息"
               :visible.sync="dialogVisible"
               width="600px"
               :before-close="handleClose">
      <el-form :model="ruleForm"
               ref="ruleForm"
               label-width="140px"
               class="demo-ruleForm">
        <el-form-item label="属性名称"
                      :rules="[
      { required: true, message: '请输入属性名称'}
    ]"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item label="字段名(英文)"
                      :rules="[
      { required: true, message: '请输入字段名(英文)'}
    ]"
                      prop="fieldName">
          <el-input v-model="ruleForm.fieldName"
                    :disabled="type == 'edit'"
                    size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="排序"
                      :rules="[
      { required: true, message: '请输入排序数字'}
    ]"
                      prop="sort">
          <el-input v-model="ruleForm.sort"
                    size="small"
                    type="number"></el-input>
        </el-form-item>
        <el-form-item label="录入方式"
                      prop="input">
          <el-radio-group v-model="ruleForm.input">
            <el-radio label="0">文本框</el-radio>
            <el-radio label="1">多行文本框</el-radio>
            <el-radio label="2">下拉框</el-radio>
            <el-radio label="3">上传文件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="列表页筛选"
                      prop="listPageFilter">
          <el-checkbox v-model="ruleForm.listPageFilter"></el-checkbox>
        </el-form-item>
        <el-form-item label="大商城详情页展示"
                      prop="mallDetailPage">
          <el-checkbox v-model="ruleForm.mallDetailPage"></el-checkbox>
        </el-form-item>
        <el-form-item label="商品添加基库展示"
                      prop="goodsBaseShow">
          <el-checkbox v-model="ruleForm.goodsBaseShow"></el-checkbox>
        </el-form-item>
        <el-form-item label="是否必填"
                      prop="required">
          <el-checkbox v-model="ruleForm.required"></el-checkbox>
        </el-form-item>
        <el-form-item v-show="ruleForm.input == '2'"
                      :rules=" ruleForm.input == '2' ? [
                        { required: true, message: '请输入下拉框枚举值'}
                      ]: [] "
                      label="下拉框枚举值"
                      prop="selectEnum">
          <el-input size="small"
                    placeholder="每个枚举值之间用中文逗号隔开，比如张三，李四"
                    v-model="ruleForm.selectEnum"
                    type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   size="small">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="submit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除商品类型"
               :visible.sync="dialogVisibleDelete"
               width="30%"
               :before-close="handleCloseDelete">
      <span>请确认是否要删除商品属性，历史商品的属性值也会删除</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="dialogVisibleDelete = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="deleteShop">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable'
import { compgoodsattributeDelete, getAttributeByTypeId, compgoodsattributeSave, compgoodsattributeUpdate } from '@/api/productManage/goodsManger'
// import avater from "/public/img/default.png"

export default {
  name: 'WareProduct',
  components: { MyTable },
  data () {
    return {
      row: '',
      type: '',
      name: '',
      id: '',
      dialogVisibleDelete: false,
      showpage: false,
      dialogVisible: false,
      ruleForm: {
        fieldName: '',
        sort: '',
        selectEnum: '',
        input: '0',
        required: '',
        goodsBaseShow: '',
        mallDetailPage: '',
        listPageFilter: '',
        name: '',
      },
      // avater: avater,
      // formTool: {
      //   name: '',
      //   approvalNumber: ''
      // },
      // selectionList: [],
      operation: true,
      // selection: true,
      index: false,
      tableData: [],
      tableOption: [
        // { label: '商品信息', prop: 'image', slot: true, minWidth: '200px' }, // 这里表示自定义列
        // { label: '商品名称', prop: 'name' },
        // { label: '生产厂商', prop: 'factory' },
        { label: '属性名称', prop: 'name' },
        { label: '列表页筛选', prop: 'listPageFilter', slot: true },
        { label: '大商城详情页展示', prop: 'mallDetailPage', slot: true },
        { label: '商品添加基库展示', prop: 'goodsBaseShow', slot: true },
        { label: '是否必填', prop: 'required', slot: true },
        { label: '录入方式', prop: 'input', slot: true },
        { label: '排序', prop: 'sort' },
      ]
    }
  },
  computed: {},
  watch: {},
  created () {
    this.id = this.$route.query.id
    this.name = this.$route.query.name
    this.getAttributeByTypeId()
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  methods: {
    handleCloseDelete () {
      this.dialogVisibleDelete = false
    },
    // 确定删除
    deleteShop () {
      compgoodsattributeDelete({ id: this.row.id }).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败')
        }
        this.dialogVisibleDelete = false
        this.getAttributeByTypeId()
      })
    },
    clickBtn (type) {
      if (type == 'add') {
        this.type = 'add'
        this.dialogVisible = true
      } else {
        this.type = 'edit'
        this.dialogVisible = true
      }
    },
    // 手动关闭弹窗
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.dialogVisible = false
    },
    // 提交信息
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            let params = {
              ...this.ruleForm,
              typeId: this.id,
              id: ''
            }
            compgoodsattributeSave(params).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功')
                this.getAttributeByTypeId()
              } else {
                this.$message.error('新增失败')
              }
              this.handleClose()
            })
          } else {
            let params = {
              ...this.ruleForm,
              typeId: this.id
            }
            compgoodsattributeUpdate(params).then(res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.getAttributeByTypeId()
              } else {
                this.$message.error('操作失败')
              }
            })
            this.handleClose()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    // 编辑sku
    editHandle (row) {
      this.clickBtn('edit')
      setTimeout(() => {
        this.row = row
        this.ruleForm = { ...row }
        this.ruleForm.input = String(row.input)
      }, 100)

    },
    deleteHandle (row) {
      this.row = row
      this.dialogVisibleDelete = true
      // const params = [{
      //   goodsId: row.goodsId
      // }]
      // putaway(params).then(res => {
      //   if (res.code === 0) {
      //     this.$message.success('上架成功')
      //     this.reset()
      //     // this.getAttributeByTypeId(1)
      //   } else {
      //     this.$message.error('上架失败')
      //   }
      // })
    },
    // 查询
    getAttributeByTypeId () {
      getAttributeByTypeId({ typeId: this.id, isMerchant: false }).then(res => {
        if (res.code == 0 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 120px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    // position: absolute;
    // z-index: 2;
    // bottom: -45px;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 0px;
  }
}
</style>
